
// This file is now a thin wrapper around the modular hooks implementation
// for backward compatibility

import { useWidgetDefinitions as useModularWidgetDefinitions } from './widgets';
export { useWidgetDefinitions };

function useWidgetDefinitions() {
  return useModularWidgetDefinitions();
}
